import { Badge } from "@shopify/polaris";
import type { InternalOrderStatus } from "../types";

const STATUS_CONFIG: Record<InternalOrderStatus, { tone: "success" | "warning" | "critical" | "info" | "attention" | "new"; label: string }> = {
  new_backlog: { tone: "new", label: "New" },
  queued: { tone: "info", label: "Queued" },
  pending: { tone: "info", label: "Pending" },
  label_purchased: { tone: "attention", label: "Label purchased" },
  printed: { tone: "success", label: "Printed" },
  failed: { tone: "critical", label: "Failed" },
  // Distinct from Failed on purpose: the postage is bought and paid for, so the
  // work left is a reprint, not a repurchase.
  print_failed: { tone: "warning", label: "Bought, not printed" },
  no_rule_match: { tone: "warning", label: "No rule matched" },
  skipped: { tone: "info", label: "Skipped" },
};

export default function StatusBadge({ status }: { status: InternalOrderStatus }): JSX.Element {
  const config = STATUS_CONFIG[status];
  return <Badge tone={config.tone}>{config.label}</Badge>;
}
